import { Button } from "antd";
import { EditFilled } from "@ant-design/icons";
import { useState } from "react";
import Modal from "../../../../components/generic/Modal";
import Pricing from "../Pricing";

const ChangePlanModal = ({ isCanceled }) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <Button
        icon={<EditFilled />}
        type="primary"
        onClick={() => setShowModal(true)}
      >
        Update Plan
      </Button>
      {showModal && (
        <Modal
          open
          style={{
            top: "8px",
            padding: 0,
            height: "calc(100dvh - 16px)",
          }}
          width={"100dvw"}
          styles={{
            container: {
              height: "calc(100dvh - 16px)",
              overflow: "auto",
              padding: 0,
            },
          }}
          onCancel={() => setShowModal(false)}
          footer={null}
        >
          <Pricing
            closeModal={() => setShowModal(false)}
            isCanceled={isCanceled}
          />
        </Modal>
      )}
    </>
  );
};

export default ChangePlanModal;
